import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'GBCDisconnectedLayout',
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: '35932428-2464-4112-a641-9c7a3c3eabfd',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2936f649-5d9e-494c-8b2f-ebe2948e1123',
      type: 'NineSlicePlane',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 38,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 445,
        y: 301
      },
      width: 890,
      height: 602,
      leftWidth: 100,
      topHeight: 300,
      rightWidth: 102,
      bottomHeight: 273,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'mission_board',
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '16429772-d7b7-4a75-8625-cb4f6577d2ce',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -206,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '0fd9d156-b7cc-489c-a876-0ca86131ed9b',
      type: 'Container',
      name: 'disconnectedContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '3b8a5e48-8e05-4499-bc7e-77ae56083534',
      type: 'Container',
      name: 'connectingContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '35932428-2464-4112-a641-9c7a3c3eabfd',
      data: ''
    },
    {
      id: '45897e65-c703-4a78-8b02-5b3e92453c37',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Disconnected',
      localize: true,
      maxWidth: 423,
      maxHeight: 93,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '0x903030',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '16429772-d7b7-4a75-8625-cb4f6577d2ce',
      data: ''
    },
    {
      id: 'f5b0735b-463e-48c8-9a27-40a9ac0df2c4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 283,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.9,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_bg',
      parent: '0fd9d156-b7cc-489c-a876-0ca86131ed9b',
      data: ''
    },
    {
      id: 'abf80f0c-4173-48e5-8b55-fd7a03b8c3a5',
      type: 'Text',
      name: 'disconnectedText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 37,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'DisconnectedFromGBCDesc',
      localize: true,
      maxWidth: 800,
      maxHeight: 300,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0fd9d156-b7cc-489c-a876-0ca86131ed9b',
      data: ''
    },
    {
      id: 'cdbf6dbc-89ab-458b-a188-423dea9d39db',
      type: 'Sprite',
      name: 'loadingSpinner',
      nameSpace: '',
      className: '',
      x: 0,
      y: 37,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.5,
        y: 2.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loading_farm_icon',
      parent: '3b8a5e48-8e05-4499-bc7e-77ae56083534',
      data: ''
    },
    {
      id: '22e66b36-feb7-4000-a1bb-1d327b67bede',
      type: 'Text',
      name: 'connectingText',
      nameSpace: '',
      className: '',
      x: 0,
      y: 110,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Connecting',
      localize: true,
      maxWidth: 800,
      maxHeight: 300,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#bb3c2f',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '3b8a5e48-8e05-4499-bc7e-77ae56083534',
      data: ''
    },
    {
      id: 'a2677eb7-8dad-47fd-9b60-f5bec509efb0',
      type: 'Sprite',
      name: 'reconnectBtn',
      nameSpace: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: 'f5b0735b-463e-48c8-9a27-40a9ac0df2c4',
      data: ''
    },
    {
      id: '3ba01d03-f18d-419f-b6b2-6598408a9bfd',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Reconnect',
      localize: true,
      maxWidth: 201,
      maxHeight: 71,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#3a7b0e',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a2677eb7-8dad-47fd-9b60-f5bec509efb0',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class GBCDisconnectedLayout {
  static raw = raw;
  root: PIXI.Container
  bg: PIXI.NineSlicePlane
  disconnectedContainer: PIXI.Container
  reconnectBtn: PIXI.Sprite
  disconnectedText: PIXI.Text
  connectingContainer: PIXI.Container
  loadingSpinner: PIXI.Sprite
  connectingText: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
